<template>
  <div class="storePage">
    <div class="left">
      <!-- <div class="operation">
        <div style="margin: 0 8px 0 0; width: 50px">主进程</div>
        <Radio-group v-model="isOpen" @on-change="changeRadio">
          <Radio :label="1">启</Radio>
          <Radio :label="0">停</Radio>
        </Radio-group>
      </div> -->
      <div
        :class="[
          'singleTab',
          curTab == index ? 'active' : '',
          item.status ? 'ServerActivate' : '',
        ]"
        @click="changeTab(index)"
        v-for="(item, index) in tab"
        :key="index"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right">
      <scp v-if="!curTab"></scp>
      <scu v-if="curTab == 1"></scu>
      <dicom v-if="curTab == 2"></dicom>
      <imageMake v-if="curTab == 3"></imageMake>
      <worklist v-if="curTab == 4"></worklist>
      <imageZip v-if="curTab == 5"></imageZip>
      <imageMove v-if="curTab == 6"></imageMove>
      <qa v-if="curTab == 7"></qa>
      <clear v-if="curTab == 8"></clear>
    </div>
  </div>
</template>
<script>
import scp from "./components/scp.vue";
import scu from "./components/scu.vue";
import dicom from "./components/dicom.vue";
import imageMake from "./components/imageMake";
import worklist from "./components/worklist";
import imageZip from "./components/imageZip";
import imageMove from "./components/imageMove";
import qa from "./components/qa.vue";
import clear from "./components/clear.vue";
export default {
  components: { scp, scu, dicom, imageMake, worklist, imageZip, imageMove, qa,clear },
  data() {
    return {
      status: true,
      LogsData: [],
      tab: [
        {
          name: "C-Store SCP服务",
          serviceSign: "ProcessCenterSCP",
          status: false,
        },
        {
          name: "C-Store SCU服务",
          serviceSign: "ProcessCenterSCU",
          status: false,
        },
        {
          name: "DICOM QR服务",
          serviceSign: "ProcessCenterQR",
          status: false,
        },
        {
          name: "影像归档服务",
          serviceSign: "ProcessImageArchive",
          status: false,
        },
        {
          name: "WorkList服务",
          serviceSign: "ProcessWorkList",
          status: false,
        },
        {
          name: "影像压缩服务",
          serviceSign: "ProcessCenterOOSUpload",
          status: false,
        },
        {
          name: "影像迁移服务",
          serviceSign: "ProcessCenterOOSUpload",
          status: false,
        },
        {
          name: "QA服务",
          serviceSign: "ProcessSendImageToRIS",
          status: false,
        },
        {
          name: "中心影像数据清除服务",
          serviceSign: "ProcessCenterDataClean",
          status: true,
        },
      ],
      isOpen: null,
      curTab: 0,
    };
  },
  methods: {
    getLogs() {
      this.$api.get("dictionary/GetLogConfigurationEnum").then((res) => {
        this.LogsData = res.data;
      });
    },
    getServerStatus() {
      this.$api.get("/dictionary/getServiceStatusList").then((res) => {
        this.tab
          .forEach((item) => {
            res.data.forEach((items) => {
              if (item.serviceSign == items.serviceSign) {
                console.log(item);
                return (item.status = items.serviceStatus == 10);
              }
            });
          })
          .then(() => {
            this.$set(this.tab, this.tab);
          });
      });
    },
    changeTab(index) {
      this.curTab = index;
    },
    changeRadio(val) {
      console.log(val, 988);
      if (val) {
        this.$api.get(`dictionary/allOn`).then((res) => {
          this.$Message.error(res.msg);
        });
      } else if (!val) {
        this.$api.get(`dictionary/allOff`).then((res) => {
          this.$Message.error(res.msg);
        });
      } else {
      }
    },
  },
  created() {
    this.getLogs();
    this.getServerStatus();
  },
};
</script>
<style scoped lang="scss">
.storePage {
  display: flex;

  .left {
    width: 189px;
    position: absolute;
    background: #ffffff;
    border-radius: 12px;
    position: absolute;
    top: 100px;
    bottom: 16px;
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;

    .operation {
      display: flex;
      color: #666666;
      margin: 0 0 10px 0;
    }

    .singleTab {
      width: 157px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdcdc;
      color: #333;
      margin: 8px 0 0 0;
      cursor: pointer;
    }

    .ServerActivate {
      border: 1px solid #e5f6f0;
      background-color: #e5f6f0;
    }

    .ServerStop {
    }

    .active {
      border: 2px solid #338bff;
    }
  }

  .right {
    width: calc(100% - 430px);
    position: absolute;
    background: #ffffff;
    border-radius: 12px;
    position: absolute;
    top: 100px;
    bottom: 16px;
    left: 420px;
    overflow-y: auto;
    padding: 24px;
  }
}

/deep/ .ivu-input-number {
  width: 186px;
  // padding: 4px 7px;
  box-sizing: border-box;
}
</style>